// eslint-disable-next-line
import { CogniteClient } from '@cognite/sdk';
import ReactUnifiedViewer, {
  ToolConfig,
  TooltipConfig,
  UnifiedViewerEventListenerMap,
  UnifiedViewerEventType,
  UnifiedViewerNode,
  UnifiedViewer,
  UnifiedViewerPointerEvent,
} from '@cognite/unified-file-viewer';
import React from 'react';
import { getClient } from 'config/cognitesdk';

type IdsByType = {
  containerIds: string[];
  annotationIds: string[];
};

type UnifiedFileViewerProps = {
  applicationId: string;
  shouldUseAdaptiveRendering: boolean;
  nodes: UnifiedViewerNode[];
  tool?: ToolConfig;
  tooltips?: TooltipConfig[];
  onClick?: (event: UnifiedViewerPointerEvent) => void;
  cogniteClient?: CogniteClient;
  shouldAllowDragDrop?: boolean;
  onUpdateRequest?: UnifiedViewerEventListenerMap[UnifiedViewerEventType.ON_UPDATE_REQUEST];
  renderContextMenu?: (ids: IdsByType) => React.ReactElement | null;
  onSelect?: UnifiedViewerEventListenerMap[UnifiedViewerEventType.ON_SELECT];
  setRef?: (ref: UnifiedViewer) => void;
};

const UnifiedFileViewer = ({
  applicationId,
  shouldUseAdaptiveRendering,
  nodes,
  tool,
  tooltips,
  onClick,
  shouldAllowDragDrop,
  onUpdateRequest,
  renderContextMenu,
  onSelect,
  setRef,
}: UnifiedFileViewerProps) => {
  return (
    <ReactUnifiedViewer
      id="container"
      applicationId={applicationId}
      shouldUseAdaptiveRendering={shouldUseAdaptiveRendering}
      nodes={nodes}
      tool={tool}
      tooltips={tooltips}
      onClick={onClick}
      cogniteClient={getClient() as any}
      shouldAllowDragDrop={shouldAllowDragDrop}
      onUpdateRequest={onUpdateRequest}
      renderContextMenu={renderContextMenu}
      onSelect={onSelect}
      setRef={setRef}
    />
  );
};

export default UnifiedFileViewer;
